module.exports = __webpack_public_path__ + "media/images/projects/localisation_icon-36e6e3aea73b31ef0d3dcc75f5e7ae35.svg";